export const services = [
  {
    id: 0,
    title: "Geodatabase Development",
    image: "/service-geodatabase-development.svg",
    detailImage: "/cover-geodatabase-development.svg",
    description:
      "Ensure your spatial and attribute data are organized, scalable, and ready for advanced analysis.",
    features: [
      "Design and organization",
      "Implementation of data integrity rules",
      "Setup of relationship classes",
      "Support for multi-user environments",
      "Automation and integration",           
    ],
    imageWidth: "65%",
    imageHeight: "100%",
    objectFit: "object-contain",
  },
  {
    id: 1,
    title: "Desktop Mapping",
    image: "/service-desktop-mapping.jpg",
    detailImage: "/cover-desktop-mapping.png",
    description:
      "Transform geospatial data into clear, compelling, and decision-ready maps using industry standard ArcGIS Pro and QGIS.",
    features: [
      "Custom base maps",
      "Advanced cartographic styling and symbology",
      "Thematic mapping",
      "Spatial analysis",
      "High-resolution map exports",
    ],
  },
  {
    id: 2,
    title: "Web Mapping",
    image: "/service-web-mapping.png",
    detailImage: "/cover-web-mapping.png",
    description:
      "Bring your spatial data to life through dynamic, interactive web maps built with platforms like ArcGIS Online, Leaflet, and Mapbox.",
    features: [
      "Custom web map applications",
      "Interactive layers and pop-ups",
      "Real-time data integration",
      "Thematic and operational web maps",
      "Mobile-responsive, shareable map interfaces",
    ],
  },
  {
    id: 3,
    title: "Web Apps",
    image: "/service-web-apps.jpg",
    detailImage: "/cover-web-apps.png",
    description:
      "Turn complex spatial workflows into intuitive, browser-based applications that empower users to explore, analyze, and act on geospatial data in real time.",
    features: [
      "Tailored web app interfaces",
      "Integrated spatial tools (filters, queries, measurements)",
      "Real-time dashboards and visual indicators",
      "Secure access with user roles and permissions",
      "Optimized for desktop and mobile devices",
    ],
  },
  {
    id: 4,
    title: "3D Analysis",
    image: "/service-3d-analysis.jpg",
    detailImage: "/cover-3d-analysis.jpg",
    description:
      "Elevate your spatial insights with 3D GIS analysis—visualize terrain, infrastructure, and urban environments in three dimensions.",
    features: [
      "3D terrain and surface modeling",
      "Building and infrastructure visualization",
      "Viewshed and line-of-sight analysis",
      "Subsurface analysis and underground utility mapping",
      "Interactive 3D web scenes for presentations and planning",
    ],
  },
  {
    id: 5,
    title: "Spatial Analysis",
    image: "/service-spatial-analysis.png",
    detailImage: "/cover-spatial-analysis.png",
    description:
      "Unlock hidden patterns, relationships, and trends in your data through advanced spatial analysis powered by GIS.",
    features: [
      "Proximity and buffer analysis",
      "Overlay and intersection analysis",
      "Hotspot and cluster detection",
      "Terrain and hydrological modeling",
      "Statistical and spatial correlation analysis",
    ],
    
  },
  {
    id: 6,
    title: "Network Analysis",
    image: "/service-network-analysis.jpg",
    detailImage: "/cover-network-analysis.png",
    description:
      "Optimize routes, assess accessibility, and model real-world movement with precision using GIS-based network analysis.",
    features: [
      "Route optimization and shortest path analysis",
      "Service area and drive-time mapping",
      "Closest facility identification",
      "Multi-modal transportation modeling",
      "Network dataset creation and customization",
    ],
    
  },
  {
    id: 7,
    title: "Spatial Statistics",
    image: "/service-spatial-statistics.jpg",
    detailImage: "/cover-spatial-statistics.png",
    description:
      "Gain deeper insights from your geospatial data and uncover patterns, anomalies, and spatial relationships that traditional analysis might miss.",
    features: [
      "Hotspot and cold spot analysis",
      "Spatial autocorrelation",
      "Regression and predictive modeling",
      "Point pattern and density analysis",
      "Trend surface and interpolation techniques",
    ],
  },
  {
    id: 8,
    title: "BIM GIS",
    image: "/service-bim-gis.svg",
    detailImage: "/cover-bim-gis.svg",
    description:
      "Bridge the gap between spatial intelligence and building design by integrating GIS with BIM. We help you connect detailed BIM models with real-world geographic context.",
    features: [
      "BIM-GIS data integration",
      "3D building visualization",
      "Infrastructure and utilities mapping",
      "Site suitability and impact analysis",
      "Support for urban planning, construction, and asset management",
    ],
  },
  {
    id: 9,
    title: "Marine GIS",
    image: "/service-marine-gis.jpg",
    detailImage: "/cover-marine-GIS.png",
    description:
      "Support coastal and marine projects with precision using GIS tools tailored for offshore, nearshore, and maritime environments.",
    features: [
      "Mapping of coastlines, seabed, and bathymetry",
      "Marine spatial planning and zoning",
      "Vessel tracking and route analysis",
      "Environmental impact assessment and habitat mapping",
      "Integration of hydrographic and oceanographic data",
    ],    
  },
  {
    id: 10,
    title: "Data Visualization",
    image: "/service-data-visualization.png",
    // detailImage: "/cover-data-visualization.png",
    detailImage: "/ds.png",
    description:
      "Turn complex data into clear, interactive visuals that drive smarter decisions. Our custom dashboards help you monitor key metrics, track performance, and share insights—beautifully and efficiently.",
    features: [
      "Interactive dashboards using Power BI, Tableau, or Python",
      "Custom visualizations tailored to your industry and audience",
      "Real-time data integration and automated reporting",
      "Clean, intuitive layouts designed for non-technical users",
      "Decision-ready insights at a glance",
    ],
    imageWidth: "70%",
    imageHeight: "100%",
    objectFit: "object-contain",
  },
  {
    id: 11,
    title: "Data Warehousing",
    image: "/service-data-warehousing.svg",
    detailImage: "/cover-data-warehousing.svg",
    description:
      "Centralize and streamline your organization’s data with robust data warehousing solutions. We design scalable, secure, and query-optimized data environments that support analytics, reporting, and business intelligence across all sectors.",
    features: [
      "Design and implementation",
      "Integration from multiple sources",
      "ETL (Extract, Transform, Load)",
      "Support for cloud and on-premise",
      "Modeling and optimization for fast querying and dashboarding",
    ],
    imageWidth: "55%",
    imageHeight: "100%",
    objectFit: "object-contain",
  },
]
